import { IFilterEquipoBySupervisor } from "../../Interfaces/IEquipo";
import { ITableFilterPersonas } from "../../Interfaces/IPersona";

export const InitialFilterPersonas: ITableFilterPersonas = {
  skip: 0,
  take: 50,
  search: "",
  guardia: "",
  areaId: null,
  puestoId: null,
};

export const InitialFilterSupervisores: IFilterEquipoBySupervisor = {
  skip: 0,
  take: 50,
  search: "",
  supervisorId: null,
};
